export default __webpack_public_path__ + "media/0d1498db3282dcd659b19dbd04ee420930cfd640d30ca7f848858b85812b6c4c.svg";